import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  Typography,
  useTheme,
  Chip,
} from '@mui/material';
import { useServices } from '../../hooks/service/useServices';
import { Service } from '../../types/service';

interface ServiceSelectProps {
  selectedService: string[];
  onChange: (serviceAddonId: string[]) => void;
  availableService?: Service[];
  error?: boolean;
  helperText?: string;
}

const ServiceSelect: React.FC<ServiceSelectProps> = ({
  selectedService,
  onChange,
  availableService,
  error,
  helperText,
}) => {
  const theme = useTheme();
  const { services: allServices } = useServices();

  const services = availableService || allServices;

  return (
    <FormControl fullWidth error={error}>
      <InputLabel>Select Service</InputLabel>
      {/* <Select
        value={selectedService || ''}
        onChange={e =>
          onChange(typeof e.target.value === 'string' ? [e.target.value] : e.target.value)
        }
        label="Select Service"
        disabled={!serviceAddonId}
      > */}
      <Select
        value={selectedService || ''}
        onChange={e => onChange([e.target.value.toString()])}
        label="Select Service"
        // disabled={!serviceAddonId}
      >
        {services.map(service => (
          <MenuItem key={service.id} value={service.id}>
            <Box sx={{ py: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <Typography variant="body1">{service.name}</Typography>
                <Chip
                  label={`${service.duration} min`}
                  size="small"
                  sx={{
                    backgroundColor: `${theme.palette.primary.main}15`,
                    color: theme.palette.primary.main,
                  }}
                />
              </Box>
              {/* <Typography variant="body2" color="text.secondary">
                {service.description}
              </Typography> */}
            </Box>
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {!services && <FormHelperText>Please select a service first</FormHelperText>}
    </FormControl>
  );
};

export default ServiceSelect;
